import { storableError } from '../../util/errors';
import { denormalisedResponseEntities } from '../../util/data';
import { getFavoriteListings } from '../../ducks/favorites.duck';

// ================ Action types ================ //

export const FETCH_BOOKMARKED_LISTINGS_REQUEST =
  'app/BookmarkedListingsPage/FETCH_BOOKMARKED_LISTINGS_REQUEST';
export const FETCH_BOOKMARKED_LISTINGS_SUCCESS =
  'app/BookmarkedListingsPage/FETCH_BOOKMARKED_LISTINGS_SUCCESS';
export const FETCH_BOOKMARKED_LISTINGS_ERROR =
  'app/BookmarkedListingsPage/FETCH_BOOKMARKED_LISTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  bookmarkedListings: [],
  bookmarkedListingsError: null,
  fetchBookmarkedListingsInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_BOOKMARKED_LISTINGS_REQUEST:
      return {
        ...state,
        fetchBookmarkedListingsInProgress: true,
        bookmarkedListingsError: null,
      };
    case FETCH_BOOKMARKED_LISTINGS_SUCCESS:
      return {
        ...state,
        bookmarkedListings: payload,
        fetchBookmarkedListingsInProgress: false,
      };
    case FETCH_BOOKMARKED_LISTINGS_ERROR:
      return {
        ...state,
        bookmarkedListingsError: payload,
        fetchBookmarkedListingsInProgress: false,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchBookmarkedListingsRequest = () => ({
  type: FETCH_BOOKMARKED_LISTINGS_REQUEST,
});

export const fetchBookmarkedListingsSuccess = listings => ({
  type: FETCH_BOOKMARKED_LISTINGS_SUCCESS,
  payload: listings,
});

export const fetchBookmarkedListingsError = error => ({
  type: FETCH_BOOKMARKED_LISTINGS_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const fetchBookmarkedListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchBookmarkedListingsRequest());

  const favoriteListingIds = getFavoriteListings(getState());

  // If no favorites, return empty array
  if (!favoriteListingIds || favoriteListingIds.length === 0) {
    dispatch(fetchBookmarkedListingsSuccess([]));
    return Promise.resolve([]);
  }

  // Fetch all favorited listings
  return sdk.listings
    .query({
      ids: favoriteListingIds,
      include: ['author', 'images'],
      'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
    })
    .then(response => {
      // Denormalize the response to include images and author data
      const listings = denormalisedResponseEntities(response);
      dispatch(fetchBookmarkedListingsSuccess(listings));
      return listings;
    })
    .catch(e => {
      dispatch(fetchBookmarkedListingsError(storableError(e)));
      throw e;
    });
};

// ================ Page data loading ================ //

export const loadData = (params, search, config) => {
  // This function is called from server side for SSR
  // We don't need to fetch bookmarked listings on server side
  // They will be fetched on client side in useEffect
  return (dispatch, getState, sdk) => {
    return Promise.resolve();
  };
};
